import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { LogOut, ShieldCheck } from "lucide-react";

const NAV = {
  admin: [
    ["/buku", "Buku"], ["/permintaan", "Permintaan"], ["/sapuan", "Sapuan"],
    ["/akses", "Akses"], ["/pamit", "Pamit"], ["/dampak", "Dampak"], ["/angka-dasar", "Angka Dasar"],
    ["/ruang-kerja", "Ruang Kerja"],
  ],
  pemilik: [["/buku", "Buku"], ["/permintaan", "Permintaan"]],
  hr: [["/pamit", "Pamit"]],
  manajer: [["/dampak", "Dampak"], ["/buku", "Bukti Kontrol"]],
};

const LABEL_PERAN = { admin: "Admin IT", pemilik: "Pemilik Akses", hr: "HR", manajer: "Manajer" };

export default function Shell({ children }) {
  const { user, keluar } = useAuth();
  const nav = useNavigate();
  if (!user) return null;
  return (
    <div className="min-h-screen flex flex-col">
      <header className="kaca border-b sticky top-0 z-20">
        <div className="px-4 md:px-8 h-14 flex items-center gap-4">
          <Link to="/" data-testid="nav-beranda" className="flex items-center gap-2 shrink-0">
            <ShieldCheck size={18} className="text-primary" aria-hidden="true" />
            <span className="font-heading font-bold text-lg">PAM-IT</span>
          </Link>
          <nav className="flex-1 flex gap-1 overflow-x-auto" aria-label="Navigasi utama">
            {(NAV[user.peran] || []).map(([to, label]) => (
              <NavLink key={to} to={to} data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-1.5 text-sm whitespace-nowrap rounded transition-colors duration-150 ${isActive ? "bg-primary text-primary-foreground font-semibold" : "text-muted-foreground hover:text-foreground hover:bg-secondary"}`}>
                {label}
              </NavLink>
            ))}
          </nav>
          <span className="hidden md:block text-xs text-muted-foreground" data-testid="info-pengguna">
            {user.perusahaan_nama ? `${user.perusahaan_nama} · ` : ""}{user.nama} · {LABEL_PERAN[user.peran]}
          </span>
          <button data-testid="tombol-keluar" aria-label="Keluar"
            onClick={() => { keluar(); nav("/"); }}
            className="tombol-garis p-2 rounded">
            <LogOut size={16} />
          </button>
        </div>
      </header>
      <main className="halaman-kerja flex-1 px-4 py-8 md:px-8 md:py-10 max-w-[1400px] w-full mx-auto">
        {children}
      </main>
      <footer className="border-t px-4 md:px-8 py-4 text-xs text-muted-foreground">
        Yang dibuka tercatat. Yang ditutup ada buktinya.
      </footer>
    </div>
  );
}
